import { createFileRoute, notFound } from "@tanstack/react-router";
import { CategorySubServicePageEn, subServiceJsonLdEn } from "@/components/CategorySubServicePageEn";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";


export const Route = createFileRoute("/en/accounting/$service")({
  loader: async ({ params }) => {
    const { PILLARS_EN } = await import("@/data/category-pillars-extra");
    const pillar = PILLARS_EN["accounting"];
    const service = pillar.subservices.find((s) => s.slug === params.service);
    if (!service) throw notFound();
    return { pillar, service };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return { meta: [{ title: "Service unavailable" }, { name: "robots", content: "noindex" }] };
    const { pillar, service } = loaderData;
    const url = `${SEO_SITE}/en/accounting/${service.slug}`;
    const title = `${service.title} — Accounting & Tax Thailand | NYC`;
    const desc = `${service.summary}. English-speaking specialists, ${service.turnaround || "3–7 days"} turnaround, LINE support.`;
    return {
      meta: [
        { title: ctaTitle(title, "/en/accounting/$service", "en") },
        { name: "description", content: ctaDesc(desc, "/en/accounting/$service", "en") },
        { property: "og:title", content: ctaTitle(title, "/en/accounting/$service", "en") },
        { property: "og:description", content: ctaDesc(desc, "/en/accounting/$service", "en") },
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "en", href: url },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: subServiceJsonLdEn(pillar, service, url),
    };
  },
  component: RouteComp,
  notFoundComponent: () => <div className="p-10 text-center">Service not found.</div>,
});

function RouteComp() {
  const { pillar, service } = Route.useLoaderData();
  return <CategorySubServicePageEn pillar={pillar} service={service} parentPath="/en/accounting" />;
}
